var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5C21 3.89543 20.0051 3 18.7778 3H15.4444M21 5V19M21 5V9M21 19C21 20.1046 20.0051 21 18.7778 21H3.22222C1.99492 21 1 20.1046 1 19M21 19V9M1 19V5M1 19V9M1 5C1 3.89543 1.99492 3 3.22222 3H6.55556M1 5V9M15.4444 1V3M15.4444 5V3M6.55556 1V3M6.55556 5V3M1 9H21M6.55556 3H15.4444",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0b9a21f1b7d52e692c57e1c76597cd09.svg";
export { ForwardRef as ReactComponent };